module.exports = __webpack_public_path__ + "static/media/img-bot-left.c99436ff.png";